"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: "targetSegmentSop",
      searchQuery: {
        year: null
      },
      apiModule: "kpiSet"
    };
  },
  computed: {
    domData: function domData() {
      return {
        year: {
          label: this.$t("common.year2"),
          valueKey: "year",
          inputType: "date",
          type: "year"
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t("sfe.route.targetsegmentsop"),
          apiUrl: "/protected/monthlyVehicleKpi/export"
        },
        import: {
          apiUrl: "/protected/monthlyVehicleKpi/import"
        }
      };
    },
    tableDom: function tableDom() {
      var _this$createMonth12Li = this.createMonth12List(),
        month12ListSuv = _this$createMonth12Li.month12ListSuv,
        month12ListLux = _this$createMonth12Li.month12ListLux,
        month12ListEvt = _this$createMonth12Li.month12ListEvt;
      return (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({
        brand: {
          label: this.$t("common.brand")
        },
        year: {
          label: this.$t("common.year2")
        },
        kpiType: {
          label: this.$t("sfe.targetsegmentsop.kpiType")
        }
      }, month12ListSuv), month12ListLux), month12ListEvt);
    },
    listApi: function listApi() {
      return {
        apiUrl: "/protected/monthlyVehicleKpi/list"
      };
    }
  },
  methods: {
    createMonth12List: function createMonth12List() {
      var _this = this;
      var month12 = new Array(12).toString().split(",").map(function (t, i) {
        return i + 1;
      });
      var month12ListSuv = {};
      var month12ListLux = {};
      var month12ListEvt = {};
      month12.forEach(function (m) {
        var number = m >= 10 ? m : "0".concat(m);
        month12ListSuv["targetCountSuv".concat(number)] = {
          label: _this.$t("sfe.targetsegmentsop.salesSUVMonth".concat(m)),
          isCommasNumber: true
        };
        month12ListLux["targetCountLux".concat(number)] = {
          label: _this.$t("sfe.targetsegmentsop.salesLUXMonth".concat(m)),
          isCommasNumber: true
        };
        month12ListEvt["targetCountEv".concat(number)] = {
          label: _this.$t("sfe.targetsegmentsop.salesEVMonth".concat(m)),
          isCommasNumber: true
        };
      });
      return {
        month12ListSuv: month12ListSuv,
        month12ListLux: month12ListLux,
        month12ListEvt: month12ListEvt
      };
    }
  }
};